import { gql } from '@apollo/client/core';

export const writeCertificationStatus = gql`
  mutation writeCertificationStatus($input: CertificationInput!) {
    hotelX {
      certification(data: $input) {
        written
        adviseMessage {
          code
          description
        }
      }
    }
  }
`;
